import { PageLevelTableWrapper, TOAST_TYPE } from '@base'
import { Table, useTableReducer } from '@baseV2'
import { strings, transactionTypeDuePayments } from '@constants'
import { getduePaymentsReport } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { paths } from '@routes'
import { removeTrailingSlash } from '@utils'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'

const DuePayments = () => {
	const globalDispatch = useDispatch()
	const [state, dispatch, actions] = useTableReducer()
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const currentPath = removeTrailingSlash(pathname)

	useEffect(() => {
		dispatch(actions.fetchTableDataProgress())
		let transactionType = currentPath === paths.admin_advance_to_supplier ? transactionTypeDuePayments.purchase : null
		getduePaymentsReport(transactionType)
			.then((response) => {
				dispatch(actions.fetchTableDataSuccess(response, response.count))
			})
			.catch((err) => {
				dispatch(actions.fetchTableDataFailure(err))
				globalDispatch(showToast(true, strings('msg_failed_to_fetch'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				globalDispatch(showLoader(false))
			})
	}, [state.query, pathname])

	const baseColumns = useMemo(
		currentPath !== paths.admin_advance_to_supplier
			? () => [
				{
					label: strings('id'),
					key: 'organisation_id',
					cellWidth: 8,
					renderer: (id) => <div style={{ whiteSpace: 'nowrap' }}>{id}</div>,
					mobile: true,
				},
				{
					label: strings('organisation'),
					key: 'organisation',
					cellWidth: 11,
					mobile: true,
				},
				{
					label: strings('current'),
					key: 'current',
					cellWidth: 6,
					mobile: true,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>{strings('1-7')}</span>,
					key: '1-7',
					cellWidth: 5,
					mobile: true,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>{strings('8-14')}</span>,
					key: '8-14',
					cellWidth: 5,
					mobile: false,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>15-21</span>,
					key: '15-21',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>22-28</span>,
					key: '22-28',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>29-35</span>,
					key: '29-35',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>36-42</span>,
					key: '36-42',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: <span style={{ whiteSpace: 'nowrap' }}>42+</span>,
					key: '42+',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: strings('total'),
					key: 'total',
					cellWidth: 7,
					mobile: true,
				},
				{
					label: strings('interest'),
					key: 'interest',
					cellWidth: 7,
					mobile: false,
				},
				{
					label: strings('sales', 'person'),
					key: 'sales_person',
					cellWidth: 8,
					mobile: true,
				},
				{
					label: strings('region'),
					key: 'region',
					cellWidth: 6,
					mobile: false,
				},
				{
					label: strings('platform'),
					key: 'platform',
					cellWidth: 7,
					mobile: false,
				},
			]
			: () => [
				{
					label: strings('id'),
					key: 'organisation_id',
					renderer: (id) => <div style={{ whiteSpace: 'nowrap' }}>{id}</div>,
					mobile: true,
				},

				{
					label: strings('organisation'),
					key: 'organisation',
					mobile: true,
				},

				{
					label: strings('total'),
					key: 'total',
					mobile: true,
				},

				{
					label: strings('supply', 'person'),
					key: 'supply_person',
					mobile: true,
				},
				{
					label: strings('region'),
					key: 'region',
					mobile: false,
				},
				{
					label: strings('platform'),
					key: 'platform',
					mobile: false,
				},
				{
					label: strings(['last', 'Payment', 'date']),
					key: 'lastPaymentDate',
					mobile: false,
				},
			],
		[pathname]
	)

	// v2 Table enables sorting by default; keep all columns non-sortable (same as the old table).
	const columns = useMemo(() => baseColumns.map((col) => ({ ...col, sortable: false })), [baseColumns])
	const rowClickHandler = (rowData) => {
		rowData?.organisation_id && navigate(paths.admin_organisations_mbook_ledger(rowData?.organisation_id))
	}

	return (
		<PageLevelTableWrapper>
			<Table
				fullHeight
				data={state.data}
				columns={columns}
				loading={state.loading}
				totalItemCount={state.total_count}
				page={state.query.page}
				hideFooter={true}
				rowClickable={true}
				onRowClick={rowClickHandler}
			/>
		</PageLevelTableWrapper>
	)
}

export default DuePayments
